var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBima = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 29,
    viewBox: "0 0 78 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6654 0.213934C39.153 -0.0723035 38.5238 -0.0712646 38.0125 0.21679L1.70669 20.6715C0.650825 21.2663 3.41308e-09 22.3675 3.41308e-09 23.5596C-0.00013271 27.3459 3.87006 29.9638 7.49168 28.6272L16.7328 25.2171C30.9834 19.9582 46.701 19.9372 60.9661 25.1579L70.5114 28.6511C74.1362 29.9778 78.0003 27.3562 78 23.5706C77.9999 22.3726 77.3436 21.2666 76.2802 20.6724L39.6654 0.213934ZM38.7529 6.70237C36.0523 6.70237 33.8629 8.84376 33.8629 11.4853C33.8629 14.1269 36.0523 16.2684 38.7529 16.2684C41.4535 16.2684 43.6427 14.1269 43.6427 11.4853C43.6427 8.84376 41.4535 6.70237 38.7529 6.70237Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBima);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bima.dd6fc6eaa7914caf39970df2404998ec.svg";